import { PropsWithChildren } from "react";

export interface MDSPanelHeaderProps extends PropsWithChildren {
  bottomBorderColor?: string;
}

export enum MDSPanelHeaderSlotName {
  Heading = "heading",
  Subsection = "subsection",
  Actions = "actions",
}
